export function resolveSmgEnvironment(configEnvironment: string | undefined, dotenvEnvironment: string | undefined): { raw: string | undefined, effective: string } {
  const raw = configEnvironment || dotenvEnvironment;
  return {raw, effective: raw || 'local'};
}
